/* ==========================================================
   Full-Screen Image Banner — Behavior
   - Pauses the Ken Burns animation whenever the banner scrolls
     out of the viewport (saves CPU/battery on long pages).
   - Resumes it automatically when it re-enters view.
   - Works for multiple banner instances on the same page.
   ========================================================== */

(function () {
  function initMagazineBanners() {
    var banners = document.querySelectorAll('.magazine-banner');
    if (!banners.length) return;

    banners.forEach(function (section) {
      var media = section.querySelector('[data-mb-media]');
      if (!media) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                media.classList.remove('magazine-banner__media--paused');
              } else {
                media.classList.add('magazine-banner__media--paused');
              }
            });
          },
          { threshold: 0.05 }
        );

        observer.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMagazineBanners);
  } else {
    initMagazineBanners();
  }

  // Re-init if Shopify section editor re-renders this section
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.magazine-banner')) {
      initMagazineBanners();
    }
  });
})();
